export const checkLineAngle = (angle: number): number => {
  const adjustedAngle = angle - 90;
  if (adjustedAngle < 0) {
    return adjustedAngle + 360;
  }

  return adjustedAngle;
};
